module.exports = __webpack_public_path__ + "img/floor_f12_01.5030ec12.png";